module.exports = __webpack_public_path__ + "img/1.df82f2af.png";